<p-dialog
  [(visible)]="showModal"
  [modal]="true"
  [styleClass]="'custom-dialog'"
  [contentStyleClass]="'custom-dialog-content'"
  [closable]="false"
  [dismissableMask]="false"
  [showHeader]="false"
>
  <div class="modal-header-shell" [@fadeSwitch]="activeSection">
    <div class="modal-header">
      <h2 id="legalModalTitle" class="modal-title">
        {{ activeSection === 'eula' ? ("LEGAL.EULA_1" | translate) : ("LEGAL.PRIVACY_POLICY_1" |
        translate) }}
      </h2>
      <div class="version-label">
        {{ activeSection === 'eula' ? 'EULA v1.1 – Effective September 1, 2026' : 'Privacy Policy
        v1.0 – Effective February 2023' }}
      </div>
    </div>
  </div>

  <div class="scroll-progress">
    <div class="scroll-bar" [ngStyle]="{ width: scrollPercent + '%' }"></div>
  </div>

  <div
    class="modal-section-wrapper"
    #termsSection
    tabindex="0"
    role="region"
    aria-labelledby="legalModalTitle"
    (scroll)="onScroll(termsSection)"
  >
    <div class="modal-section">
      <ng-container *ngComponentOutlet="sectionComponent"></ng-container>
    </div>
  </div>

  <div *ngIf="activeSection === 'eula' && showAcceptButton" class="scroll-note">
    <i class="bi bi-info-circle"></i>
    Please review the entire agreement carefully. You must scroll to the end before accepting.
  </div>

  <div class="modal-footer">
    <button
      type="button"
      [ngClass]="{
        'btn': true,
        'btn-outline-secondary': !(activeSection === 'eula' && showAcceptButton),
        'btn-secondary': activeSection === 'eula' && showAcceptButton
      }"
      (click)="activeSection === 'eula' && showAcceptButton ? decline() : close()"
    >
      {{ activeSection === 'eula' && showAcceptButton ? ("LEGAL.DECLINE" | translate) :
      ("LEGAL.CLOSE" | translate) }}
    </button>
    <button
      type="button"
      class="btn btn-accept"
      *ngIf="showAcceptButton"
      [disabled]="!canAccept"
      (click)="accept()"
    >
      {{ "LEGAL.ACCEPT" | translate }}
    </button>
  </div>
</p-dialog>
